import moment from "moment";
import { standardizing } from "../plugins/helpers";

const state = {
  bin: [],
  articles: [],
  sessions: [],
  rooms: [],
  room: "",
  date: moment().format("DD"),
  keySearch: "",
  session: "",
};

const getters = {
  articles(state) {
    return state.articles;
  },
  sessions(state) {
    return state.sessions;
  },
  rooms(state) {
    return state.rooms;
  },
  room(state) {
    return state.room;
  },
  date(state) {
    return state.date;
  },
  keySearch(state) {
    return state.keySearch;
  },
  session() {
    return state.session;
  },
};

const mutations = {
  SET_ARTICLES(state, payload) {
    state.articles = JSON.parse(JSON.stringify(payload));
    state.bin = JSON.parse(JSON.stringify(payload));
  },
  SET_SESSIONS(state, payload) {
    state.sessions = payload;
  },
  SET_ROOMS(state, payload) {
    state.rooms = payload;
  },
  SET_DATE(state, payload) {
    state.date = payload;
  },
  SET_SESSION(state, payload) {
    state.session = payload;

    var articles = JSON.parse(JSON.stringify(state.bin));
    if (state.room) {
      articles = articles.filter((a) => a.Room == state.room);
    }
    if (state.session) {
      articles = articles.filter((a) => a.Session == state.session);
    }
    if (state.keySearch) {
      var keySearch = standardizing(state.keySearch);
      articles = articles.filter(
        (a) =>
          standardizing(a.Title).includes(keySearch) ||
          standardizing(a.Author).includes(keySearch)
      );
    }
    state.articles = articles;
  },
  SET_ROOM(state, payload) {
    state.room = payload;

    var articles = JSON.parse(JSON.stringify(state.bin));
    if (state.room) {
      articles = articles.filter((a) => a.Room == state.room);
    }
    if (state.session) {
      articles = articles.filter((a) => a.Session == state.session);
    }
    if (state.keySearch) {
      var keySearch = standardizing(state.keySearch);
      articles = articles.filter(
        (a) =>
          standardizing(a.Title).includes(keySearch) ||
          standardizing(a.Author).includes(keySearch)
      );
    }
    state.articles = articles;
  },
  SET_KEYSEARCH(state, payload) {
    state.keySearch = payload;

    var articles = JSON.parse(JSON.stringify(state.bin));
    if (state.room) {
      articles = articles.filter((a) => a.Room == state.room);
    }
    if (state.session) {
      articles = articles.filter((a) => a.Session == state.session);
    }
    if (state.keySearch) {
      var keySearch = standardizing(state.keySearch);
      articles = articles.filter(
        (a) =>
          (a.Title && standardizing(a.Title).includes(keySearch)) ||
          (a.Author && standardizing(a.Author).includes(keySearch))
      );
    }
    state.articles = articles;
  },
};

export default {
  namespaced: "Article",
  state,
  mutations,
  getters,
};
